"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFormaterFunc = void 0;
var defaultFormaterFunc = function (rotation) {
    var _a;
    if (rotation.mediafileType !== 0) {
        var result = {
            rotationId: rotation.id,
            type: "promo",
            playtime: rotation.playtime.format("HH:mm:ss"),
            endTime: rotation.endTime,
            mediafileId: rotation.mediafileId,
            companyId: rotation.adcompanyId,
            promoId: rotation.promoId,
        };
        return result;
    }
    else {
        var result = {
            rotationId: rotation.id,
            type: "media",
            playtime: rotation.playtime.format("HH:mm:ss"),
            endTime: rotation.endTime,
            mediafileId: rotation.mediafileId,
            blockId: rotation.blockId,
            tagId: rotation.tagId,
            performerTitle: (_a = rotation.mediafile) === null || _a === void 0 ? void 0 : _a.performerTitle,
        };
        return result;
    }
};
exports.defaultFormaterFunc = defaultFormaterFunc;
//# sourceMappingURL=defaultFormaterFunc.js.map